export const mapUrl = (latitude: string | number, longitude: string | number) =>
	`https://yandex.ru/maps/?pt=${longitude},${latitude}&z=16&l=map`
